import { useContext, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { AuthContext } from '../../../../../core/context/AuthContext';
import { ClientContext } from '../../../../../core/context/ClientContext';
import { FacilityContext } from '../../../../../core/context/FacilityContext';
import { ContainerDisposeViewModel } from '../../../../domain/model/ContainerDisposeModel';

import { ContainerViewModel } from '../../../../domain/model/ContainerModel';
import { ContainerModelState } from '../../../../domain/model/ContainerModelState';
import { createContainerDispose } from '../../../../store/containerDisposeSlice';
import { updateContainer } from '../../../../store/containerSlice';
import { ContainerDisposeFormStep1 } from './ContainerDisposeFormStep1';
import { ContainerDisposeFormStep2 } from './ContainerDisposeFormStep2';

export interface ContainerDisposeFormProps {
	container?: ContainerViewModel;
}

export const ContainerDisposeForm = (props: ContainerDisposeFormProps): JSX.Element => {
	const { container } = props;

	// Consume the dispatch object
	const dispatch = useDispatch();

	const authContext = useContext(AuthContext);
	const clientContext = useContext(ClientContext);
	const facilityContext = useContext(FacilityContext);

	// Local state
	const [showStep1, setShowStep1] = useState<boolean>(true);
	const [invalidInputs, setInvalidInputs] = useState<string[]>([]);

	const containerDisposeModel = useRef<ContainerDisposeViewModel>({} as ContainerDisposeViewModel);

	const updatedContainer: ContainerViewModel = container;

	const requiredInputs = ['DisposedDatetime'];

	const handleChangeContainerDisposeProp = (prop: string, value: Date) => {
		containerDisposeModel.current[prop] = value;
	};

	if ((containerDisposeModel.current?.DisposedDatetime ?? null) === null) {
		containerDisposeModel.current.DisposedDatetime = new Date();
	}

	const handleUpdate = (): void => {

		containerDisposeModel.current.Client = clientContext.selectedClient().Uuid;
		containerDisposeModel.current.Facility = facilityContext.selectedFacility().Uuid;
		containerDisposeModel.current.Container = container.Uuid;
		containerDisposeModel.current.DisposedBy = authContext.getActor().Uuid;

		updatedContainer.State = ContainerModelState.DISPOSED;

		dispatch(createContainerDispose(containerDisposeModel.current));
		dispatch(updateContainer(updatedContainer));
	};

	const goToStep1 = () => {
		setShowStep1(true);
		setInvalidInputs([]);
	};

	const goToStep2 = () => {
		let newContainerDisposeModelValid = true;
		const invalidInputFields: Array<string> = [];
		for (const requiredInput of requiredInputs) {
			if (
				(containerDisposeModel.current?.[requiredInput] ?? null) === null
				|| containerDisposeModel?.current[requiredInput] === ''
				|| String(containerDisposeModel.current.requiredInput).trim().length === 0
			) {
				invalidInputFields.push(requiredInput);
				newContainerDisposeModelValid = false;
			}
		}
		setInvalidInputs(invalidInputFields);
		setShowStep1(!newContainerDisposeModelValid);
	};

	const showUpdateModalStep = showStep1 === true ?
		<ContainerDisposeFormStep1
			containerDisposeModel={containerDisposeModel.current}
			onClickNext={goToStep2}
			onChangeContainerDisposeProp={handleChangeContainerDisposeProp}
			invalidInputs={invalidInputs}
		/> :
		<ContainerDisposeFormStep2
			containerDisposeModel={containerDisposeModel.current}
			onClickPrevious={goToStep1}
			onClickConfirm={handleUpdate}
		/>;

	return (
		<>
			{showUpdateModalStep}
		</>
	);
};
